// extracted by mini-css-extract-plugin
export default {"app":"App_app__QuKn0","results":"App_results__XuFyQ"};